/* eslint-disable no-restricted-syntax */
import * as React from 'react';

import { ReloadOutlined } from '@ant-design/icons';
import {
  Button,
  ButtonType,
  CaretDownOutlined,
  Checkbox,
  LoadingOutlined,
  Modal,
  Notification,
  Popover,
  PopoverPlacement,
  Row,
  Text,
} from 'farmhub-ui-core';
import html2canvas from 'html2canvas';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import { createFileName, useScreenshot } from 'use-react-screenshot';

import { useAppDispatch, useAppSelector } from 'app';
import {
  Action,
  CButton,
  MultiSelector,
  NameText,
  SettingInfoVisible,
} from 'components';
import { CheckFilledIcon } from 'components/Icon';
import {
  handleExportPaymentBill,
  handleExportWarehouseBill,
} from 'containers/WarehouseOperation/commons';
import { useLocalStorage } from 'hooks';
import {
  cancelExportBillModal,
  findEntitySubCategoryWithEntity,
  findOneOrderBill,
  findOrderBills,
  selectProductUnit,
} from 'slice';
import { theme } from 'styled';
import {
  buildExportFileName,
  exportImage,
  formatAppearPhoneNumber,
  formatDate,
  formatMoney,
  formatOrderItemsForTableList,
  formatQuantity,
  genWholesaleUnit,
  getFullAddress,
  getOrderItemQuantityByStatus,
  getOrderPrevStatus,
  INIT_PRODUCT_SETTING_EXPORT,
  isEmptyString,
  isWholesaleOrder,
  ORDER_STATUS,
  ProductSettingExport,
} from 'utils';

import {
  BILL_TYPE,
  dataSettingOrderInfoVisible,
  dataSettingQuantityVisible,
  dataSupplierSettingOrderInfoVisible,
  dataSupplierSettingOrderK58InfoVisible,
  defaultSettingOrderInfoVisible,
  defaultSettingQuantityVisible,
} from '../commons/data';
import { SettingBillSectionInformation } from '../components/SettingBillSection/interfaces';
import TypeBillingItem from '../components/TypeBillingItem';
import DeliveryBillContent from '../DeliveryBillContent';
import ElectronicBillContent from '../ElectronicBillContent';
import K58BillContent from '../K58BillContent';
import K80BillContent from '../K80BillContent';
import NormalBillContent from '../NormalBillContent';
import PaymentBillContent from '../PaymentBillContent';
import WarehouseBillContent from '../WarehouseBillContent';
import {
  LeftWrapper,
  PageStyle,
  RightWrapper,
  Wrapper,
  WrapperA4Border,
  WrapperBorder,
  WrapperPrint,
  BillingTypeWrapper,
  HeaderBillSection,
  BodyBillSection,
  BillSection,
  ModalStyles,
  FooterBillSection,
  WrapperPopover,
  K80PageStyle,
} from './styles';

const ElectronicBillModal = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.auth.item);
  const [orderInfo, setOrderInfo] = React.useState<any>({
    title: 'PHIẾU XUẤT KHO',
    date: `Ngày: ${moment().format('DD/MM/YYYY HH:mm')}`,
  });
  const [orderInfoExcelPaymentBill, setOrderInfoExcelPaymentBill] =
    React.useState<any>({
      title: 'HÓA ĐƠN BÁN HÀNG',
    });
  const exportBillModal = useAppSelector(state => state.exportBillModal);
  const entityID = useAppSelector(state => state.account.item?.id);
  const entityType = useAppSelector(state => state.account.item?.type);
  const productUnit = useAppSelector(selectProductUnit);
  const componentRef = React.useRef<HTMLInputElement>(null);
  const [order, setOrder] = React.useState<any>({});
  const [orders, setOrders] = React.useState<any>({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [isLoadingReload, setIsLoadingReload] = React.useState(false);
  const [billingType, setBillingType] = React.useState(BILL_TYPE[0]);
  const [settingBill, setSettingBill] =
    React.useState<SettingBillSectionInformation>({
      visibleInformation: true,
      visibleCustomer: true,
      visibleReceive: true,
      visibleSupplier: true,
    });
  const [settingQuantityVisible, setSettingQuantityVisible] =
    React.useState<any>(defaultSettingQuantityVisible);
  const [settingOrderInfoVisible, setSettingOrderInfoVisible] =
    React.useState<any>(defaultSettingOrderInfoVisible);

  const [isSettingSaving, setIsSettingSaving] = React.useState(false);
  const [isPrint, setIsPrint] = React.useState(false);
  const [isLoadingCopy, setIsLoadingCopy] = React.useState(false);
  const [isLoadingDownload, setIsLoadingDownload] = React.useState(false);
  const [isLoadingDownloadExcel, setIsLoadingDownloadExcel] =
    React.useState(false);
  const [image, takeScreenShot] = useScreenshot();
  const [currentBlog, setCurrentBlog] = React.useState<any>(null);
  const [isLoadingBlog, setIsLoadingBlog] = React.useState(false);

  const [selectEntitySubcategoryIDs, setSelectEntitySubcategoryIDs] =
    React.useState<string[]>(['-1']);
  const [columnsVisible, setColumnsVisible] = React.useState<{
    [column: string]: boolean;
  }>({});
  const [informationVisible, setInformationVisible] = React.useState<{
    [column: string]: boolean;
  }>({});
  const [settingProductLocal, setSettingProductLocal] =
    useLocalStorage<ProductSettingExport>(
      `${entityID}_export_filter_setting`,
      INIT_PRODUCT_SETTING_EXPORT
    );

  const entitySubCategoryList = useAppSelector(
    state => state.entitySubCategory.list
  );

  const isLoadedEntitySubCategory = useAppSelector(
    state => state.entitySubCategory.isLoaded
  );

  const ROUND_QUANTITY_NUMBER = 6;

  const formatEntitySubCategoryList = React.useMemo(
    () =>
      (entitySubCategoryList ?? []).map(item => {
        return {
          title: item.name,
          value: item.id,
          parent: {
            value: item?.entityCategory?.id,
            title: item?.entityCategory?.displayName || '',
          },
        };
      }),
    [entitySubCategoryList]
  );

  React.useEffect(() => {
    const initEntitySubCategoryData = async () => {
      try {
        await dispatch(findEntitySubCategoryWithEntity());
      } catch (error) {
        console.log(
          'An error occurred while finding entity sub category',
          error
        );
      }
    };
    if (!isLoadedEntitySubCategory && entitySubCategoryList?.length == 0) {
      initEntitySubCategoryData();
    }
  }, [dispatch, isLoadedEntitySubCategory]);

  const handleChangeEntitySubCategoryFilter = (ids: any) => {
    setSelectEntitySubcategoryIDs(ids);
  };

  const handleChangeColumnsVisible = (key: string, value: boolean) => {
    const newState = { ...columnsVisible, [key]: value };
    const columnQuantity = Object.values(newState).filter(item => item).length;
    if (columnQuantity > 5) {
      Notification('warning', 'Vui lòng chọn tối đa 5 cột!');
    } else {
      setColumnsVisible(newState);
    }
  };

  const handleChangeInformationVisible = (key: string, value: boolean) => {
    const newState = { ...informationVisible, [key]: value };
    setInformationVisible(newState);
  };

  const handleClear = () => {
    setOrder({});
    setOrders([]);
    setSelectEntitySubcategoryIDs(['-1']);
    setOrderInfo({
      title: 'PHIẾU XUẤT KHO',
      date: `Ngày: ${moment().format('DD/MM/YYYY HH:mm')}`,
    });
    setOrderInfoExcelPaymentBill({
      title: 'HÓA ĐƠN BÁN HÀNG',
    });
  };

  const handleCancel = () => {
    handleClear();
    dispatch(cancelExportBillModal());
  };

  const handleDownload = async () => {
    if (componentRef.current) {
      setIsLoadingDownload(true);
      setIsPrint(true);

      const name = buildExportFileName(
        `${billingType.fileName} ${orderInfo.customerName} ${order.code}`
      );

      await exportImage({
        imageName: name,
        imageType: 'png',
        ref: componentRef,
      });

      setIsLoadingDownload(false);
      setIsPrint(false);
    }
  };

  const handleCopy = async () => {
    if (currentBlog) {
      setIsLoadingCopy(true);
      setIsPrint(true);
      try {
        await window.navigator.clipboard.write([
          new ClipboardItem({
            [currentBlog.type]: currentBlog,
          }),
        ]);
        Notification('success', 'Sao chép đơn hàng thành công');
      } catch (error: any) {
        Notification('error', 'Sao chép đơn hàng thất bại', error);
      } finally {
        setIsPrint(false);
        setIsLoadingCopy(false);
      }
    }
  };

  const handleCreateImageBlob = async () => {
    if (componentRef.current) {
      setIsLoadingBlog(true);
      html2canvas(componentRef.current, { scale: 2 })
        .then(canvas => {
          canvas.toBlob(
            blob => {
              setCurrentBlog(blob);
            },
            'image/png',
            1
          );
        })
        .finally(() => {
          setIsLoadingBlog(false);
        });
    }
  };

  const formatUniqueProductOnOrderItems = orderItems => {
    const formatOrderItems = orderItems.reduce((result, orderItem) => {
      const existItemIndex = result.findIndex(
        item => item.productID === orderItem.productID
      );

      if (existItemIndex != -1) {
        result[existItemIndex] = {
          ...result[existItemIndex],
          customerQuantity:
            result[existItemIndex].customerQuantity +
            orderItem.customerQuantity,
          customerReceivedQuantity:
            result[existItemIndex].customerReceivedQuantity +
            orderItem.customerReceivedQuantity,
          supplierQuantity:
            result[existItemIndex].supplierQuantity +
            orderItem.supplierQuantity,
          supplierDeliveredQuantity:
            result[existItemIndex].supplierDeliveredQuantity +
            orderItem.supplierDeliveredQuantity,
        };

        return result;
      }

      return result.concat(orderItem);
    }, []);

    return formatOrderItems;
  };

  const initData = async () => {
    if (
      !exportBillModal.visible ||
      (!exportBillModal.data.orderID && !exportBillModal.data.orderIDs) ||
      entityType === undefined
    ) {
      return;
    }
    try {
      if (!entityID) {
        return;
      }

      setIsLoading(true);

      if (exportBillModal.data.isMultiMode) {
        const { data }: any = await dispatch(
          findOrderBills({
            orderIDs: exportBillModal.data.orderIDs,
            ...(selectEntitySubcategoryIDs.includes('-1')
              ? {}
              : {
                entitySubCategoryIDs: selectEntitySubcategoryIDs,
              }),
          })
        ).unwrap();

        if (data && data.length) {
          const newOrders: any[] = [];

          for (const dataItem of data) {
            const {
              type: orderType,
              customerID,
              status: orderStatus,
              trackingStatus,
            } = dataItem;

            const formatEntitySubCategories = dataItem.entitySubCategories.map(
              entitySubCategory => {
                const { orderItems } = entitySubCategory;
                const formatOrderItems = formatOrderItemsForTableList({
                  currentEntityID: entityID,
                  orderCustomerID: customerID,
                  orderItems: formatUniqueProductOnOrderItems(orderItems),
                  orderLogs: [],
                  orderStatus,
                  trackingStatus,
                  orderType,
                  productUnit,
                });

                return {
                  ...entitySubCategory,
                  orderItems: formatOrderItems,
                };
              }
            );

            const { orderItems } = dataItem;

            const formattedOrderItems = formatOrderItemsForTableList({
              currentEntityID: entityID,
              orderCustomerID: customerID,
              orderItems: formatUniqueProductOnOrderItems(orderItems),
              orderLogs: [],
              orderStatus,
              trackingStatus,
              orderType,
              productUnit,
            });

            setOrderInfo((prevState: any) => {
              return {
                customerName: `${dataItem?.customer?.displayName}`,
                supplierName: `${dataItem?.supplier?.displayName}`,
                customerNote: `${dataItem?.customerNote}`,
                supplierNote: `${dataItem?.supplierNote}`,
                deliveryInfo: ``,
                receivedInfo: `${dataItem.additionalInfo?.address?.title
                  } ${formatAppearPhoneNumber(
                    dataItem.additionalInfo?.address?.phoneNumber
                  )}, ${getFullAddress(
                    dataItem.additionalInfo?.address?.address,
                    dataItem.additionalInfo?.address?.district?.fullName,
                    dataItem.additionalInfo?.address?.province?.fullName,
                    dataItem.additionalInfo?.address?.ward?.fullName
                  )}`,
                ...prevState,
              };
            });
            setOrderInfoExcelPaymentBill((prevState: any) => {
              return {
                customerName: `${dataItem?.customer?.displayName}`,
                employeeName: user?.displayName ?? '',
                code: `${dataItem?.code}`,
                createdAt: `Ngày ${formatDate(
                  dataItem.createdAt,
                  'DD'
                )} tháng ${formatDate(
                  dataItem.createdAt,
                  'MM'
                )} năm ${formatDate(dataItem.createdAt, 'YYYY')}`,
                cashier: ``,
                phoneNumber:
                  formatAppearPhoneNumber(
                    dataItem?.additionalInfo?.address?.phoneNumber
                  ) || '',
                address: getFullAddress(
                  dataItem.additionalInfo?.address?.address,
                  dataItem.additionalInfo?.address?.district?.fullName,
                  dataItem.additionalInfo?.address?.province?.fullName,
                  dataItem.additionalInfo?.address?.ward?.fullName
                ),
                ...prevState,
              };
            });
            newOrders.push({
              ...dataItem,
              centralSupplier:
                dataItem.customer?.id !== dataItem.supplierCentralEntity?.id
                  ? dataItem.supplierCentralEntity
                  : dataItem.supplier,
              entitySubCategories: formatEntitySubCategories,
              orderItems: formattedOrderItems,
            });
          }

          // handle save state
          const baseOrder = exportBillModal.data.orderIDs || [];
          newOrders.sort((a, b) => {
            const indexA = baseOrder.indexOf(a.id);
            const indexB = baseOrder.indexOf(b.id);

            return indexA - indexB;
          });

          setOrder(newOrders[0]);
          setOrders(newOrders);
        }
      } else {
        const { data }: any = await dispatch(
          findOneOrderBill({
            id: exportBillModal.data.orderIDs
              ? exportBillModal.data.orderIDs[0]
              : exportBillModal.data.orderID || '',
            body: selectEntitySubcategoryIDs.includes('-1')
              ? {}
              : {
                entitySubCategoryIDs: selectEntitySubcategoryIDs,
              },
          })
        ).unwrap();
        const {
          type: orderType,
          customerID,
          status: orderStatus,
          trackingStatus,
        } = data;

        const formatEntitySubCategories = data.entitySubCategories.map(
          entitySubCategory => {
            const { orderItems } = entitySubCategory;
            const formatOrderItems = formatOrderItemsForTableList({
              currentEntityID: entityID,
              orderCustomerID: customerID,
              orderItems: formatUniqueProductOnOrderItems(orderItems),
              orderLogs: [],
              orderStatus,
              trackingStatus,
              orderType,
              productUnit,
            });

            return {
              ...entitySubCategory,
              orderItems: formatOrderItems,
            };
          }
        );

        const { orderItems } = data;

        const formattedOrderItems = formatOrderItemsForTableList({
          currentEntityID: entityID,
          orderCustomerID: customerID,
          orderItems: formatUniqueProductOnOrderItems(orderItems),
          orderLogs: [],
          orderStatus,
          trackingStatus,
          orderType,
          productUnit,
        });

        setOrderInfo((prevState: any) => {
          return {
            customerName: `${data?.customer?.displayName}`,
            supplierName: `${data?.supplier?.displayName}`,
            customerNote: `${data?.customerNote}`,
            supplierNote: `${data?.supplierNote}`,
            deliveryInfo: ``,
            receivedInfo: `${data.additionalInfo?.address?.title
              } ${formatAppearPhoneNumber(
                data.additionalInfo?.address?.phoneNumber
              )}, ${getFullAddress(
                data.additionalInfo?.address?.address,
                data.additionalInfo?.address?.district?.fullName,
                data.additionalInfo?.address?.province?.fullName,
                data.additionalInfo?.address?.ward?.fullName
              )}`,
            ...prevState,
          };
        });
        setOrderInfoExcelPaymentBill((prevState: any) => {
          return {
            customerName: `${data?.customer?.displayName}`,
            employeeName: user?.displayName ?? '',
            code: `${data?.code}`,
            createdAt: `Ngày ${formatDate(
              data.createdAt,
              'DD'
            )} tháng ${formatDate(data.createdAt, 'MM')} năm ${formatDate(
              data.createdAt,
              'YYYY'
            )}`,
            cashier: ``,
            phoneNumber:
              formatAppearPhoneNumber(
                data?.additionalInfo?.address?.phoneNumber
              ) || '',
            address: getFullAddress(
              data.additionalInfo?.address?.address,
              data.additionalInfo?.address?.district?.fullName,
              data.additionalInfo?.address?.province?.fullName,
              data.additionalInfo?.address?.ward?.fullName
            ),
            ...prevState,
          };
        });
        setOrder({
          ...data,
          centralSupplier:
            data.customer?.id !== data.supplierCentralEntity?.id
              ? data.supplierCentralEntity
              : data.supplier,
          entitySubCategories: formatEntitySubCategories,
          orderItems: formattedOrderItems,
        });
      }
    } catch (error: any) {
      Notification('error', 'Tải đơn hàng thất bại', error);
    } finally {
      setIsLoadingBlog(true);
      setIsLoading(false);
      setIsLoadingReload(false);

      if (billingType != BILL_TYPE[2] && !exportBillModal.data.isMultiMode) {
        setTimeout(() => {
          handleCreateImageBlob();
        }, 1);
      }
    }
  };

  React.useEffect(() => {
    initData();
  }, [selectEntitySubcategoryIDs, billingType]);

  React.useLayoutEffect(() => {
    if (
      exportBillModal.visible &&
      !isLoading &&
      billingType != BILL_TYPE[2] &&
      !exportBillModal.data.isMultiMode
    ) {
      setTimeout(() => {
        handleCreateImageBlob();
      }, 1);
    }
  }, [columnsVisible, informationVisible, orderInfoExcelPaymentBill]);

  React.useEffect(() => {
    if (exportBillModal.visible) {
      if (settingProductLocal) {
        if (!settingProductLocal.columnDisplay) {
          setSettingProductLocal(prevState => {
            return {
              ...prevState,
              columnDisplay: INIT_PRODUCT_SETTING_EXPORT.columnDisplay,
            };
          });
          setColumnsVisible(INIT_PRODUCT_SETTING_EXPORT.columnDisplay.default);
        } else {
          const isColumnDisplayEqual = isEqual(
            settingProductLocal.columnDisplay.default,
            columnsVisible
          );
          if (!isColumnDisplayEqual) {
            setColumnsVisible(settingProductLocal.columnDisplay.default);
          }
        }

        if (!settingProductLocal.informationDisplay) {
          setSettingProductLocal(prevState => {
            return {
              ...prevState,
              informationDisplay:
                INIT_PRODUCT_SETTING_EXPORT.informationDisplay,
            };
          });
          setInformationVisible(
            INIT_PRODUCT_SETTING_EXPORT.informationDisplay.default
          );
        } else {
          const isColumnDisplayEqual = isEqual(
            settingProductLocal.informationDisplay.default,
            informationVisible
          );
          if (!isColumnDisplayEqual) {
            setInformationVisible(
              settingProductLocal.informationDisplay.default
            );
          }
        }

        const isCategoryDisplayEqual = isEqual(
          settingProductLocal.categoryDisplay?.default,
          selectEntitySubcategoryIDs
        );
        if (!isCategoryDisplayEqual) {
          setSelectEntitySubcategoryIDs(
            settingProductLocal.categoryDisplay?.default
          );
        } else {
          initData();
        }

        if (!settingProductLocal.K80OrderInfoDisplay) {
          setSettingProductLocal(prevState => {
            return {
              ...prevState,
              K80OrderInfoDisplay:
                INIT_PRODUCT_SETTING_EXPORT.K80OrderInfoDisplay,
            };
          });
          setSettingOrderInfoVisible(
            INIT_PRODUCT_SETTING_EXPORT.K80OrderInfoDisplay.default
          );
        } else {
          const isColumnDisplayEqual = isEqual(
            settingProductLocal.K80OrderInfoDisplay.default,
            settingOrderInfoVisible
          );
          if (!isColumnDisplayEqual) {
            setSettingOrderInfoVisible(
              settingProductLocal.K80OrderInfoDisplay.default
            );
          }
        }

        if (!settingProductLocal.K80QuantityDisplay) {
          setSettingProductLocal(prevState => {
            return {
              ...prevState,
              K80QuantityDisplay:
                INIT_PRODUCT_SETTING_EXPORT.K80QuantityDisplay,
            };
          });
          setSettingQuantityVisible(
            INIT_PRODUCT_SETTING_EXPORT.K80QuantityDisplay.default
          );
        } else {
          const isColumnDisplayEqual = isEqual(
            settingProductLocal.K80QuantityDisplay.default,
            settingQuantityVisible
          );
          if (!isColumnDisplayEqual) {
            setSettingQuantityVisible(
              settingProductLocal.K80QuantityDisplay.default
            );
          }
        }
      }
    }
  }, [exportBillModal.visible]);

  const formatDataSubCategory = (entitySubCategories: any) => {
    let results: any[] = [];

    for (let index = 0; index < entitySubCategories.length; index++) {
      const element = entitySubCategories[index];
      results = [...results, { name: element.name, type: 'SUB_CATEGORY' }];
      results = [
        ...results,
        ...(element.orderItems ?? '').map((item: any) => {
          return {
            ...item.product,
            ...item,
            type: 'PRODUCT',
          };
        }),
      ];
    }

    return results;
  };

  const handleExportExcelPayment = async () => {
    setIsLoadingDownloadExcel(true);
    const title: any = [
      'STT',
      'Tên hàng hóa',
      ...(columnsVisible.SKUCode ? ['Mã SKU'] : []),
      'ĐVT',
      'Số lượng',
      ...(columnsVisible.RetailPrice ? ['Đơn giá lẻ'] : []),
      ...(columnsVisible.RetailUnit ? ['ĐVT lẻ'] : []),
      'Đơn giá mua',
      'Tiền hàng',
      ...(columnsVisible.PromotionPrice ? ['Tiền KM'] : []),
      ...(columnsVisible.SupplierNote || columnsVisible.CustomerNote
        ? ['Ghi chú']
        : []),
      ...(columnsVisible.TotalPrice ? ['Thành tiền'] : []),
    ];

    const products = informationVisible?.Category
      ? formatDataSubCategory(
        (order?.entitySubCategories ?? [])
          .map((entitySubCategory: any) => {
            return {
              ...entitySubCategory,
              orderItems: entitySubCategory.orderItems.filter(
                (orderItem: any) =>
                  informationVisible?.Quantity
                    ? getOrderItemQuantityByStatus({
                      orderItem,
                      status: order.status,
                      trackingStatus: order.trackingStatus,
                    }) > 0
                    : true
              ),
            };
          })
          .filter(
            (entitySubCategory: any) =>
              entitySubCategory.orderItems.length > 0
          )
      ).filter((item: any) =>
        informationVisible?.Category ? true : item.type != 'SUB_CATEGORY'
      )
      : (order?.orderItems ?? [])
        .map((item: any) => {
          return {
            ...item,
            type: 'PRODUCT',
          };
        })
        .filter((orderItem: any) =>
          informationVisible?.Quantity
            ? getOrderItemQuantityByStatus({
              orderItem,
              status: order.status,
              trackingStatus: order.trackingStatus,
            }) > 0
            : true
        );

    let index = informationVisible?.Category ? 0 : 1;

    const formatData = products.map((item: any) => {
      if (item.type == 'SUB_CATEGORY') {
        index = 0;
      }

      const tem = {
        index: item.type != 'SUB_CATEGORY' ? index : item?.name,
        name: item.type == 'SUB_CATEGORY' ? '' : item?.product?.name,
        ...(columnsVisible.SKUCode
          ? {
            code: item.type == 'SUB_CATEGORY' ? '' : item?.product?.code,
          }
          : {}),
        unit:
          item.type != 'SUB_CATEGORY'
            ? !isWholesaleOrder(order.type)
              ? genWholesaleUnit({
                unitPrefix:
                  productUnit.prefixObj[
                  item.supplierProductRetailUnit?.prefix
                  ],
                unitWeight: item.supplierProductRetailUnit?.weight,
                unitPostfix:
                  productUnit.postfixObj[
                  item.supplierProductRetailUnit?.postfix
                  ],
              })
              : genWholesaleUnit({
                unitPrefix:
                  productUnit.prefixObj[
                  item.customerProductWholesaleUnit?.prefix
                    ? item.customerProductWholesaleUnit?.prefix
                    : item.supplierProductWholesaleUnit?.prefix
                  ],
                unitWeight:
                  item.customerProductWholesaleUnit?.weight != null
                    ? item.customerProductWholesaleUnit?.weight
                    : item.supplierProductWholesaleUnit?.weight,
                unitPostfix:
                  productUnit.postfixObj[
                  item.customerProductWholesaleUnit?.postfix
                    ? item.customerProductWholesaleUnit?.postfix
                    : item.supplierProductWholesaleUnit?.postfix
                  ],
              })
            : '',
        quantity:
          item.type != 'SUB_CATEGORY'
            ? getOrderItemQuantityByStatus({
              orderItem: item,
              status: order.status,
              trackingStatus: order.trackingStatus,
            })
            : '',
        ...(columnsVisible.RetailPrice
          ? {
            retailPrice:
              item.type != 'SUB_CATEGORY'
                ? `${formatMoney(item.product?.price)}đ`
                : '',
          }
          : {}),
        ...(columnsVisible.RetailUnit
          ? {
            retailUnit:
              item.type != 'SUB_CATEGORY'
                ? genWholesaleUnit({
                  unitPrefix:
                    productUnit.prefixObj[item.product?.retailUnit?.prefix],
                  unitWeight: item.product?.retailUnit?.weight,
                  unitPostfix:
                    productUnit.postfixObj[
                    item.product?.retailUnit?.postfix
                    ],
                })
                : '',
          }
          : {}),
        price:
          item.type != 'SUB_CATEGORY'
            ? `${formatMoney(item.originPrice)}đ`
            : '',
        tempPrice:
          item.type != 'SUB_CATEGORY'
            ? `${formatMoney(
              item.originPrice *
              getOrderItemQuantityByStatus({
                orderItem: item,
                status: order.status,
                trackingStatus: order.trackingStatus,
              })
            )}đ` || ''
            : '',
        ...(columnsVisible.PromotionPrice
          ? {
            promotionPrice:
              item.type != 'SUB_CATEGORY'
                ? item.price != item.originPrice &&
                  (order?.additionalInfo?.promotions ?? []).length > 0
                  ? `${formatMoney(
                    (item.originPrice - item.price) *
                    getOrderItemQuantityByStatus({
                      orderItem: item,
                      status: order.status,
                      trackingStatus: order.trackingStatus,
                    })
                  )}đ`
                  : ''
                : '',
          }
          : {}),
        ...(columnsVisible.SupplierNote || columnsVisible.CustomerNote
          ? {
            note:
              item.type != 'SUB_CATEGORY'
                ? [
                  columnsVisible?.CustomerNote ? item.customerNote : '',
                  columnsVisible?.SupplierNote ? item.supplierNote : '',
                ]
                  .filter((item: string) => !isEmptyString(item))
                  .join(', ')
                : '',
          }
          : {}),
        ...(columnsVisible.TotalPrice
          ? {
            totalPrice:
              item.type != 'SUB_CATEGORY'
                ? `${formatMoney(
                  item.price *
                  getOrderItemQuantityByStatus({
                    orderItem: item,
                    status: order.status,
                    trackingStatus: order.trackingStatus,
                  })
                )}đ` || ''
                : '',
          }
          : {}),
      };

      index += 1;

      return tem;
    });

    const categoryIndex: number[] = [];

    products.forEach((item: any, index: number) => {
      if (item.type == 'SUB_CATEGORY') {
        categoryIndex.push(index + 1);
      }
    });

    const promotion =
      order?.additionalInfo?.promotions &&
        order?.additionalInfo?.promotions.length > 0
        ? order?.additionalInfo?.promotions[0]
        : undefined;

    handleExportPaymentBill({
      list: formatData,
      title,
      info: {
        title: 'HÓA ĐƠN BÁN HÀNG',
        code: `Mã hóa đơn: ${orderInfoExcelPaymentBill.code}`,
        employeeName: `Nhân viên: ${orderInfoExcelPaymentBill?.employeeName}`,
        customerName: `Khách hàng: ${orderInfoExcelPaymentBill?.customerName}`,
        createdAt: `Ngày: ${orderInfoExcelPaymentBill?.createdAt}`,
        cashier: `Thu ngân: ${orderInfoExcelPaymentBill?.cashier}`,
        phoneNumber: `SĐT: ${orderInfoExcelPaymentBill?.phoneNumber}`,
        ...(informationVisible.Address
          ? {
            address: `Địa chỉ: ${orderInfoExcelPaymentBill?.address}`,
          }
          : {}),
      },
      paymentInfo: [
        'Thông tin thanh toán',
        `Tên ngân hàng: ${order?.additionalInfo?.bankAccount
          ? order?.additionalInfo?.bankAccount.bank.tradingName
          : 'Chưa cập nhật'
        }`,
        `Số tài khoản: ${order?.additionalInfo?.bankAccount
          ? order?.additionalInfo?.bankAccount.number
          : 'Chưa cập nhật'
        }`,
        `Chủ tài khoản: ${order?.additionalInfo?.bankAccount
          ? order?.additionalInfo?.bankAccount.name
          : 'Chưa cập nhật'
        }`,
        `Ghi chú: ${order?.additionalInfo?.bankAccount
          ? order?.additionalInfo?.bankAccount?.note ?? ''
          : 'Chưa cập nhật'
        }`,
      ],
      deliveryInfo: [
        'Thông tin vân chuyển',
        ...(order?.additionalInfo?.transportNote
          ? [
            ...(order?.additionalInfo?.transportNote.description ?? []).map(
              (item: any) => item.value
            ),
          ]
          : [
            'Đơn vị vận chuyển: Chưa cập nhật',
            'Số điện thoại: Chưa cập nhật',
            'Tên tài xế: Chưa cập nhật',
          ]),
      ],
      summaryInfo: [
        {
          label: 'Tạm tính:',
          value: `${formatMoney(
            Number(order.totalPrice) +
            Number(order.totalAdjustment) -
            Number(order.deliveryFee)
          )}đ`,
        },
        {
          label: 'Phí giao hàng:',
          value: `${formatMoney(order.deliveryFee)}đ`,
        },
        {
          label: 'Giảm giá:',
          value: `${formatMoney(
            order.totalAdjustment - (promotion ? promotion?.amount : 0) > 0
              ? order.totalAdjustment - (promotion ? promotion?.amount : 0)
              : 0
          )}đ`,
        },
        ...(promotion
          ? [
            {
              label: `${promotion.name}: ${promotion?.rate && promotion?.rate > 0
                  ? `(${promotion?.rate}%)`
                  : ``
                }`,
              value: `${formatMoney(promotion?.amount)}đ`,
            },
          ]
          : []),
        {
          label: 'Tổng tiền',
          value: `${formatMoney(order.totalPrice)}đ`,
        },
      ],
      categoryIndex,
    })
      .then((url: string) => {
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', url);
        downloadAnchorNode.setAttribute(
          'download',
          `${buildExportFileName(
            `hoa don thanh toan ${orderInfo.customerName} ${order.code
            } ${formatDate(moment())}`
          )}.xlsx`
        );
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      })
      .finally(() => {
        setIsLoadingDownloadExcel(false);
      });
  };

  const handleChangeSettingQuantityVisible = values => {
    setSettingQuantityVisible((prevState: any) => {
      return {
        ...prevState,
        ...values,
      };
    });
  };

  const handleChangeSettingOrderInfoVisible = values => {
    setSettingOrderInfoVisible((prevState: any) => {
      return {
        ...prevState,
        ...values,
      };
    });
  };

  const handleExportProducts = async () => {
    setIsLoadingDownloadExcel(true);
    const title: any = [
      'STT',
      'MÃ SKU',
      'PHIẾU XUẤT KHO',
      'ĐƠN VỊ',
      'SL ĐẶT',
      'SL CHỐT',
      'SL GIAO',
      'SL NHẬN',
      'GHI CHÚ',
    ];

    const products = formatDataSubCategory(order?.entitySubCategories ?? []);

    let index = 0;

    const formatData = products.map((item: any) => {
      const standardPriceUnit = (item?.product?.wholesalePriceUnit ?? []).find(
        (item: any) => item?.isStandard && item?.isSelected
      );

      if (item.type == 'SUB_CATEGORY') {
        index = 0;
      }

      const tem = {
        index: item.type != 'SUB_CATEGORY' ? index : item?.name,
        sku: item?.product?.code,
        name: item.type == 'SUB_CATEGORY' ? '' : item?.product?.name,
        unit:
          item.type != 'SUB_CATEGORY'
            ? genWholesaleUnit({
              unitPrefix: productUnit.prefixObj[standardPriceUnit?.prefix],
              unitWeight: standardPriceUnit?.weight,
              unitPostfix: productUnit.postfixObj[standardPriceUnit?.postfix],
            })
            : '',
        customerQuantity: item.customerQuantity ?? '',
        supplierQuantity:
          [
            ORDER_STATUS.PROCESSING,
            ORDER_STATUS.DELIVERY,
            ORDER_STATUS.CUSTOMER_CONFIRM,
            ORDER_STATUS.SUPPLIER_CONFIRM,
            ORDER_STATUS.COMPLETE,
          ].includes(order.status) ||
            ([ORDER_STATUS.REJECT, ORDER_STATUS.MERGED].includes(order.status) &&
              [
                ORDER_STATUS.PROCESSING,
                ORDER_STATUS.DELIVERY,
                ORDER_STATUS.CUSTOMER_CONFIRM,
                ORDER_STATUS.SUPPLIER_CONFIRM,
                ORDER_STATUS.COMPLETE,
              ].includes(getOrderPrevStatus(order.status, order.trackingStatus)))
            ? formatQuantity(item.supplierQuantity, ROUND_QUANTITY_NUMBER)
            : '',
        deliveredQuantity:
          [
            ORDER_STATUS.DELIVERY,
            ORDER_STATUS.CUSTOMER_CONFIRM,
            ORDER_STATUS.SUPPLIER_CONFIRM,
            ORDER_STATUS.COMPLETE,
          ].includes(order.status) ||
            ([ORDER_STATUS.REJECT, ORDER_STATUS.MERGED].includes(order.status) &&
              [
                ORDER_STATUS.DELIVERY,
                ORDER_STATUS.CUSTOMER_CONFIRM,
                ORDER_STATUS.SUPPLIER_CONFIRM,
                ORDER_STATUS.COMPLETE,
              ].includes(getOrderPrevStatus(order.status, order.trackingStatus)))
            ? formatQuantity(
              item.supplierDeliveredQuantity,
              ROUND_QUANTITY_NUMBER
            )
            : '',
        receivedQuantity:
          [
            ORDER_STATUS.CUSTOMER_CONFIRM,
            ORDER_STATUS.SUPPLIER_CONFIRM,
            ORDER_STATUS.COMPLETE,
          ].includes(order.status) ||
            ([ORDER_STATUS.REJECT, ORDER_STATUS.MERGED].includes(order.status) &&
              [
                ORDER_STATUS.CUSTOMER_CONFIRM,
                ORDER_STATUS.SUPPLIER_CONFIRM,
                ORDER_STATUS.COMPLETE,
              ].includes(getOrderPrevStatus(order.status, order.trackingStatus)))
            ? formatQuantity(
              item.customerReceivedQuantity,
              ROUND_QUANTITY_NUMBER
            )
            : '',
        note: [item.customerNote, item.supplierNote]
          .filter((item: any) => !isEmptyString(item))
          .join(', '),
      };

      index += 1;

      return tem;
    });

    const categoryIndex: number[] = [];

    products.forEach((item: any, index: number) => {
      if (item.type == 'SUB_CATEGORY') {
        categoryIndex.push(index + 1);
      }
    });

    handleExportWarehouseBill({
      list: formatData,
      title,
      info: {
        title: 'PHIẾU XUẤT KHO',
        date: `Ngày: ${moment().format('DD/MM/YYYY HH:mm')}`,
        customer: `Khách hàng: ${orderInfo?.customerName}`,
        supplier: `Nhà cung cấp: ${orderInfo?.supplierName}`,
        customerNote: `Ghi chú của KH: ${orderInfo?.customerNote}`,
        supplierNote: `Ghi chú của NCC: ${orderInfo?.supplierNote}`,
        delivery: `Người giao hàng: ${orderInfo?.deliveryInfo}`,
        received: `Người nhận hàng: ${orderInfo?.receivedInfo}`,
      },
      categoryIndex,
    })
      .then((url: string) => {
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', url);
        downloadAnchorNode.setAttribute(
          'download',
          `${buildExportFileName(
            `hoa don kho ${orderInfo.customerName} ${order.code}`
          )}.xlsx`
        );
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      })
      .finally(() => {
        setIsLoadingDownloadExcel(false);
      });
  };

  const handleExportWarehouseProducts = async () => {
    setIsLoadingDownloadExcel(true);
    const title: any = [
      'STT',
      'MÃ SKU',
      'PHIẾU SƠ CHẾ',
      'ĐƠN VỊ',
      'SL ĐẶT',
      'SL GIAO',
      'SL SƠ CHẾ',
      'SL NHẬN',
      'GHI CHÚ',
    ];

    const products = formatDataSubCategory(order?.entitySubCategories ?? []);

    let index = 0;

    const formatData = products.map((item: any) => {
      const standardPriceUnit = (item?.product?.wholesalePriceUnit ?? []).find(
        (item: any) => item?.isStandard && item?.isSelected
      );

      if (item.type == 'SUB_CATEGORY') {
        index = 0;
      }

      const tem = {
        index: item.type != 'SUB_CATEGORY' ? index : item?.name,
        sku: item?.product?.code,
        name: item.type == 'SUB_CATEGORY' ? '' : item?.product?.name,
        unit:
          item.type != 'SUB_CATEGORY'
            ? genWholesaleUnit({
              unitPrefix: productUnit.prefixObj[standardPriceUnit?.prefix],
              unitWeight: standardPriceUnit?.weight,
              unitPostfix: productUnit.postfixObj[standardPriceUnit?.postfix],
            })
            : '',
        customerQuantity: item.customerQuantity ?? '',
        supplierDeliveredQuantity:
          [
            ORDER_STATUS.PROCESSING,
            ORDER_STATUS.DELIVERY,
            ORDER_STATUS.CUSTOMER_CONFIRM,
            ORDER_STATUS.SUPPLIER_CONFIRM,
            ORDER_STATUS.COMPLETE,
          ].includes(order.status) ||
            ([ORDER_STATUS.REJECT, ORDER_STATUS.MERGED].includes(order.status) &&
              [
                ORDER_STATUS.PROCESSING,
                ORDER_STATUS.DELIVERY,
                ORDER_STATUS.CUSTOMER_CONFIRM,
                ORDER_STATUS.SUPPLIER_CONFIRM,
                ORDER_STATUS.COMPLETE,
              ].includes(getOrderPrevStatus(order.status, order.trackingStatus)))
            ? formatQuantity(
              item.supplierDeliveredQuantity,
              ROUND_QUANTITY_NUMBER
            )
            : '',
        customerLossQuantity:
          [
            ORDER_STATUS.CUSTOMER_CONFIRM,
            ORDER_STATUS.SUPPLIER_CONFIRM,
            ORDER_STATUS.COMPLETE,
          ].includes(order.status) ||
            ([ORDER_STATUS.REJECT, ORDER_STATUS.MERGED].includes(order.status) &&
              [
                ORDER_STATUS.CUSTOMER_CONFIRM,
                ORDER_STATUS.SUPPLIER_CONFIRM,
                ORDER_STATUS.COMPLETE,
              ].includes(getOrderPrevStatus(order.status, order.trackingStatus)))
            ? formatQuantity(
              item.supplierDeliveredQuantity - item.customerReceivedQuantity,
              ROUND_QUANTITY_NUMBER
            )
            : '',
        receivedQuantity:
          [
            ORDER_STATUS.CUSTOMER_CONFIRM,
            ORDER_STATUS.SUPPLIER_CONFIRM,
            ORDER_STATUS.COMPLETE,
          ].includes(order.status) ||
            ([ORDER_STATUS.REJECT, ORDER_STATUS.MERGED].includes(order.status) &&
              [
                ORDER_STATUS.CUSTOMER_CONFIRM,
                ORDER_STATUS.SUPPLIER_CONFIRM,
                ORDER_STATUS.COMPLETE,
              ].includes(getOrderPrevStatus(order.status, order.trackingStatus)))
            ? formatQuantity(
              item.customerReceivedQuantity,
              ROUND_QUANTITY_NUMBER
            )
            : '',
        note: [item.customerNote, item.supplierNote]
          .filter((item: any) => !isEmptyString(item))
          .join(', '),
      };

      index += 1;

      return tem;
    });

    const categoryIndex: number[] = [];

    products.forEach((item: any, index: number) => {
      if (item.type == 'SUB_CATEGORY') {
        categoryIndex.push(index + 1);
      }
    });

    handleExportWarehouseBill({
      list: formatData,
      title,
      info: {
        title: 'PHIẾU SƠ CHẾ',
        date: `Ngày: ${moment().format('DD/MM/YYYY HH:mm')}`,
        customer: `Khách hàng: ${orderInfo?.customerName}`,
        supplier: `Nhà cung cấp: ${orderInfo?.supplierName}`,
        customerNote: `Ghi chú của KH: ${orderInfo?.customerNote}`,
        supplierNote: `Ghi chú của NCC: ${orderInfo?.supplierNote}`,
        delivery: `Người giao hàng: ${orderInfo?.deliveryInfo}`,
        received: `Người nhận hàng: ${orderInfo?.receivedInfo}`,
      },
      categoryIndex,
    })
      .then((url: string) => {
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', url);
        downloadAnchorNode.setAttribute(
          'download',
          `${buildExportFileName(
            `hoa don so che ${orderInfo.customerName} ${order.code}`
          )}.xlsx`
        );
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      })
      .finally(() => {
        setIsLoadingDownloadExcel(false);
      });
  };

  const handleReload = async () => {
    setIsLoadingReload(true);
    setIsLoading(true);
    await initData();
  };

  const handleSaveSetting = () => {
    setIsSettingSaving(true);

    setSettingProductLocal(prev => {
      return {
        ...prev,
        categoryDisplay: {
          ...prev.categoryDisplay,
          default: selectEntitySubcategoryIDs,
        },
        columnDisplay: {
          ...prev.columnDisplay,
          default: columnsVisible,
        },
        informationDisplay: {
          ...prev.informationDisplay,
          default: informationVisible,
        },
        K80OrderInfoDisplay: {
          ...prev.K80OrderInfoDisplay,
          default: settingOrderInfoVisible,
        },
        K80QuantityDisplay: {
          ...prev.K80QuantityDisplay,
          default: settingQuantityVisible,
        },
      };
    });

    setTimeout(() => {
      setIsSettingSaving(false);
    }, 1000);
  };

  const handleChangeOrderInfo = (val: any) => {
    setOrderInfo((prevState: any) => {
      return {
        ...prevState,
        ...val,
      };
    });
  };

  const handleChangeOrderInfoExcel = (val: any) => {
    setOrderInfoExcelPaymentBill((prevState: any) => {
      return {
        ...prevState,
        ...val,
      };
    });
  };

  const handleAfterChangeVisibleSetting = () => {
    if (!exportBillModal.data.isMultiMode) {
      handleCreateImageBlob();
    }
  };

  const selectColumnDisplayPopoverContent = React.useMemo(
    () => (
      <WrapperPopover>
        <Checkbox
          checked={columnsVisible.SKUCode}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('SKUCode', e.target.checked)
          }
        >
          <NameText color="black">Mã SKU</NameText>
        </Checkbox>
        <Checkbox
          checked={columnsVisible.RetailPrice}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('RetailPrice', e.target.checked)
          }
        >
          <NameText color="black">Đơn giá lẻ</NameText>
        </Checkbox>
        <Checkbox
          checked={columnsVisible.RetailUnit}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('RetailUnit', e.target.checked)
          }
        >
          <NameText color="black">ĐVT lẻ</NameText>
        </Checkbox>
        <Checkbox
          checked={columnsVisible.PromotionPrice}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('PromotionPrice', e.target.checked)
          }
        >
          <NameText color="black">Tiền KM</NameText>
        </Checkbox>
        <Checkbox
          checked={columnsVisible.SupplierNote}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('SupplierNote', e.target.checked)
          }
        >
          <NameText color="black">Ghi chú NCC</NameText>
        </Checkbox>
        <Checkbox
          checked={columnsVisible.CustomerNote}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('CustomerNote', e.target.checked)
          }
        >
          <NameText color="black">Ghi chú KH</NameText>
        </Checkbox>
        <Checkbox
          checked={columnsVisible.TotalPrice}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeColumnsVisible('TotalPrice', e.target.checked)
          }
        >
          <NameText color="black">Thành tiền</NameText>
        </Checkbox>
      </WrapperPopover>
    ),
    [columnsVisible]
  );

  const buildExportFunction = type => {
    if (type == 'NORMAL') {
      return handleExportProducts();
    }
    if (type == 'PAYMENT') {
      return handleExportExcelPayment();
    }
    if (type == 'WAREHOUSE') {
      return handleExportWarehouseProducts();
    }

    return null;
  };

  const selectInformationDisplayPopoverContent = React.useMemo(
    () => (
      <WrapperPopover>
        <Checkbox
          checked={informationVisible.Address}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeInformationVisible('Address', e.target.checked)
          }
        >
          <NameText color="black">Địa chỉ nhận hàng</NameText>
        </Checkbox>
        <Checkbox
          checked={informationVisible.Quantity}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeInformationVisible('Quantity', e.target.checked)
          }
        >
          <NameText color="black">Sản phẩm có số lượng</NameText>
        </Checkbox>
        <Checkbox
          checked={informationVisible?.Category}
          styles={{ margin: '0px !important' }}
          onChange={e =>
            handleChangeInformationVisible('Category', e.target.checked)
          }
        >
          <NameText color="black">Danh mục</NameText>
        </Checkbox>
      </WrapperPopover>
    ),
    [informationVisible]
  );

  return (
    <Wrapper onClick={(e: any) => e.stopPropagation()}>
      <Modal
        centered
        destroyOnClose
        displayFooter={false}
        styles={ModalStyles}
        visible={exportBillModal.visible}
        width={theme.modal.width.lg}
        onCancel={handleCancel}
      >
        <Wrapper>
          <LeftWrapper>
            <Row
              justifyContent="space-between"
              styles={{ padding: '18px 12px' }}
            >
              <Text color="primary" weight="bold">
                Mẫu hóa đơn:
              </Text>
              <Action
                iconProps={{ width: '16px', height: '16px' }}
                onClick={handleReload}
              >
                {isLoadingReload ? (
                  <LoadingOutlined spin />
                ) : (
                  <ReloadOutlined
                    style={{ fontSize: 16, color: theme.colors.text.secondary }}
                  />
                )}
              </Action>
            </Row>
            <BillingTypeWrapper className="overlay">
              {BILL_TYPE.map((item: any) => (
                <Row onClick={() => setBillingType(item)}>
                  <TypeBillingItem
                    icon={item.icon}
                    selected={item.code == billingType.code}
                    title={item.name}
                  />
                </Row>
              ))}
            </BillingTypeWrapper>
          </LeftWrapper>
          <RightWrapper>
            <BillSection>
              <HeaderBillSection>
                <Row justifyContent="space-between" width="100%">
                  <Text color="primary" weight="bold">
                    {billingType.name}{' '}
                    {orders.length > 0 ? (
                      <Text color="main" weight="bold">
                        (Mẫu in)
                      </Text>
                    ) : (
                      ''
                    )}
                  </Text>
                  <Row styles={{ gap: 12 }} width="fit-content">
                    <MultiSelector
                      childName="Danh mục con"
                      containerID="container"
                      name="Danh mục"
                      optionSelected={selectEntitySubcategoryIDs}
                      options={formatEntitySubCategoryList}
                      tooltip="Lọc danh mục"
                      type="GROUP"
                      onSelected={handleChangeEntitySubCategoryFilter}
                    >
                      <Button
                        height="36px"
                        styles={{
                          'justify-content': 'space-between',
                          'flex-shrink': 0,
                        }}
                        type={ButtonType.Default}
                        width="180px"
                      >
                        <span>
                          {selectEntitySubcategoryIDs.includes('-1')
                            ? 'Tất cả danh mục'
                            : `Đã chọn: ${selectEntitySubcategoryIDs.length} Danh mục`}
                        </span>
                        <CaretDownOutlined color="#BFBFBF" />
                      </Button>
                    </MultiSelector>
                    {billingType.code === 'PAYMENT' && (
                      <>
                        <Popover
                          align={{ targetOffset: [0, 10] }}
                          content={selectInformationDisplayPopoverContent}
                          placement={PopoverPlacement.BottomLeft}
                          trigger="click"
                          width="220px"
                        >
                          <Button
                            height={theme.button.height.sm}
                            type={ButtonType.Default}
                          >
                            Thông tin cần xuất
                          </Button>
                        </Popover>
                        <Popover
                          align={{ targetOffset: [0, 10] }}
                          content={selectColumnDisplayPopoverContent}
                          placement={PopoverPlacement.BottomLeft}
                          trigger="click"
                          width="160px"
                        >
                          <Button
                            height={theme.button.height.sm}
                            type={ButtonType.Default}
                          >
                            Cột cần xuất
                          </Button>
                        </Popover>
                      </>
                    )}
                    {billingType.code === 'K80' && (
                      <>
                        <SettingInfoVisible
                          data={dataSettingQuantityVisible}
                          title="Hiển thị số lượng"
                          values={settingQuantityVisible}
                          onAfterChanged={handleAfterChangeVisibleSetting}
                          onChangeSetting={handleChangeSettingQuantityVisible}
                        />
                      </>
                    )}
                    {(billingType.code === 'DELIVERY' ||
                      billingType.code === 'A4' ||
                      billingType.code === 'K58' ||
                      billingType.code === 'K80') && (
                        <SettingInfoVisible
                          data={
                            billingType.code === 'K80'
                              ? dataSettingOrderInfoVisible
                              : dataSupplierSettingOrderInfoVisible
                          }
                          title="Hiển thị thông tin"
                          values={settingOrderInfoVisible}
                          onAfterChanged={handleAfterChangeVisibleSetting}
                          onChangeSetting={handleChangeSettingOrderInfoVisible}
                        />
                      )}
                    {billingType.code === 'K58' && (
                      <SettingInfoVisible
                        data={dataSupplierSettingOrderK58InfoVisible}
                        title="Hiển thị thông tin"
                        values={settingOrderInfoVisible}
                        onAfterChanged={handleAfterChangeVisibleSetting}
                        onChangeSetting={handleChangeSettingOrderInfoVisible}
                      />
                    )}
                    <Button
                      key="1"
                      ghost
                      height={theme.button.height.sm}
                      loading={isSettingSaving}
                      onClick={handleSaveSetting}
                    >
                      Lưu bộ lọc
                    </Button>
                  </Row>
                </Row>
              </HeaderBillSection>
              <BodyBillSection className="overlay">
                {billingType.code === 'NORMAL' && order && (
                  <WrapperBorder>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <NormalBillContent
                        isLoading={isLoading}
                        order={order}
                        onChangeOrderInfo={handleChangeOrderInfo}
                        onCreateImage={handleCreateImageBlob}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <NormalBillContent
                              isLoading={isLoading}
                              order={item}
                              padding="0px 24px"
                              onChangeOrderInfo={handleChangeOrderInfo}
                              onCreateImage={handleCreateImageBlob}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperBorder>
                )}
                {billingType.code === 'PAYMENT' && (
                  <WrapperBorder>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <PaymentBillContent
                        columnsVisible={columnsVisible}
                        informationVisible={informationVisible}
                        isLoading={isLoading}
                        order={order}
                        onChangeOrderInfo={handleChangeOrderInfoExcel}
                        onCreateImage={handleCreateImageBlob}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <PaymentBillContent
                              columnsVisible={columnsVisible}
                              informationVisible={informationVisible}
                              isLoading={isLoading}
                              order={item}
                              padding="0px 24px"
                              onChangeOrderInfo={handleChangeOrderInfoExcel}
                              onCreateImage={handleCreateImageBlob}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperBorder>
                )}
                {billingType.code === 'DELIVERY' && (
                  <WrapperBorder>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <DeliveryBillContent
                        isLoading={isLoading}
                        order={{
                          code: order.code,
                          deliveryAvatar: settingOrderInfoVisible.isSupplier
                            ? settingOrderInfoVisible.isAvatarText
                              ? order?.supplier?.avatarText
                              : order?.supplier?.avatar
                            : settingOrderInfoVisible.isAvatarText
                              ? order?.centralSupplier?.avatarText
                              : order?.centralSupplier?.avatar,
                          deliveryName: settingOrderInfoVisible.isSupplier
                            ? order.supplier?.displayName
                            : order.centralSupplier?.displayName,
                          deliveryAddress: settingOrderInfoVisible.isSupplier
                            ? getFullAddress(
                              order.supplier?.address,
                              order.supplier?.ward?.district?.fullName,
                              order.supplier?.ward?.province?.fullName,
                              order.supplier?.ward?.fullName
                            )
                            : getFullAddress(
                              order.centralSupplier?.address,
                              order.centralSupplier?.ward?.district?.fullName,
                              order.centralSupplier?.ward?.province?.fullName,
                              order.centralSupplier?.ward?.fullName
                            ),
                          deliveryPhoneNumber:
                            settingOrderInfoVisible.isSupplier
                              ? formatAppearPhoneNumber(
                                order?.supplier?.phoneNumber
                              )
                              : formatAppearPhoneNumber(
                                order?.centralSupplier?.phoneNumber
                              ),
                          receiveName: order.additionalInfo?.address?.title,
                          receiveAddress: getFullAddress(
                            order.additionalInfo?.address?.address,
                            order.additionalInfo?.address?.district?.fullName,
                            order.additionalInfo?.address?.province?.fullName,
                            order.additionalInfo?.address?.ward?.fullName
                          ),
                          receivePhoneNumber: formatAppearPhoneNumber(
                            order.additionalInfo?.address?.phoneNumber
                          ),
                        }}
                        onCreateImage={handleCreateImageBlob}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <DeliveryBillContent
                              isLoading={isLoading}
                              order={{
                                code: item.code,
                                deliveryAvatar:
                                  settingOrderInfoVisible.isSupplier
                                    ? settingOrderInfoVisible.isAvatarText
                                      ? item?.supplier?.avatarText
                                      : item?.supplier?.avatar
                                    : settingOrderInfoVisible.isAvatarText
                                      ? item?.centralSupplier?.avatarText
                                      : item?.centralSupplier?.avatar,
                                deliveryName: settingOrderInfoVisible.isSupplier
                                  ? item.supplier?.displayName
                                  : item.centralSupplier?.displayName,
                                deliveryAddress:
                                  settingOrderInfoVisible.isSupplier
                                    ? getFullAddress(
                                      item.supplier?.address,
                                      item.supplier?.ward?.district?.fullName,
                                      item.supplier?.ward?.province?.fullName,
                                      item.supplier?.ward?.fullName
                                    )
                                    : getFullAddress(
                                      item.centralSupplier?.address,
                                      item.centralSupplier?.ward?.district
                                        ?.fullName,
                                      item.centralSupplier?.ward?.province
                                        ?.fullName,
                                      item.centralSupplier?.ward?.fullName
                                    ),
                                deliveryPhoneNumber:
                                  settingOrderInfoVisible.isSupplier
                                    ? formatAppearPhoneNumber(
                                      item?.supplier?.phoneNumber
                                    )
                                    : formatAppearPhoneNumber(
                                      item?.centralSupplier?.phoneNumber
                                    ),
                                receiveName:
                                  item.additionalInfo?.address?.title,
                                receiveAddress: getFullAddress(
                                  item.additionalInfo?.address?.address,
                                  item.additionalInfo?.address?.district
                                    ?.fullName,
                                  item.additionalInfo?.address?.province
                                    ?.fullName,
                                  item.additionalInfo?.address?.ward?.fullName
                                ),
                                receivePhoneNumber: formatAppearPhoneNumber(
                                  item.additionalInfo?.address?.phoneNumber
                                ),
                              }}
                              onCreateImage={handleCreateImageBlob}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperBorder>
                )}
                {billingType.code === 'WAREHOUSE' && (
                  <WrapperBorder>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <WarehouseBillContent
                        isLoading={isLoading}
                        order={order}
                        onCreateImage={handleCreateImageBlob}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <WarehouseBillContent
                              isLoading={isLoading}
                              order={item}
                              padding="0px 24px"
                              onCreateImage={handleCreateImageBlob}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperBorder>
                )}
                {billingType.code === 'A4' && (
                  <WrapperA4Border>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <ElectronicBillContent
                        isLoading={isLoading}
                        order={{
                          ...order,
                          supplier: settingOrderInfoVisible.isSupplier
                            ? {
                              ...order.supplier,
                              avatar: settingOrderInfoVisible.isAvatarText
                                ? order.supplier?.avatarText
                                : order.supplier?.avatar,
                            }
                            : {
                              ...order.centralSupplier,
                              avatar: settingOrderInfoVisible.isAvatarText
                                ? order.centralSupplier?.avatarText
                                : order.centralSupplier?.avatar,
                            },
                        }}
                        setting={settingBill}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <ElectronicBillContent
                              isMultiBill
                              isLoading={isLoading}
                              order={{
                                ...item,
                                supplier: settingOrderInfoVisible.isSupplier
                                  ? {
                                    ...item.supplier,
                                    avatar:
                                      settingOrderInfoVisible.isAvatarText
                                        ? item.supplier?.avatarText
                                        : item.supplier?.avatar,
                                  }
                                  : {
                                    ...item.centralSupplier,
                                    avatar:
                                      settingOrderInfoVisible.isAvatarText
                                        ? item.centralSupplier?.avatarText
                                        : item.centralSupplier?.avatar,
                                  },
                              }}
                              setting={settingBill}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperA4Border>
                )}
                {billingType.code === 'K58' && (
                  <WrapperBorder>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <K58BillContent
                        bill={{
                          ...order,
                          supplier: settingOrderInfoVisible.isSupplier
                            ? order.supplier
                            : order.centralSupplier,
                        }}
                        isLoading={isLoading}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <K58BillContent
                              bill={{
                                ...item,
                                supplier: settingOrderInfoVisible.isSupplier
                                  ? item.supplier
                                  : item.centralSupplier,
                              }}
                              isLoading={isLoading}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperBorder>
                )}
                {billingType.code === 'K80' && (
                  <WrapperBorder>
                    <WrapperPrint ref={!orders.length ? componentRef : null}>
                      <K80BillContent
                        bill={{
                          ...order,
                          supplier: settingOrderInfoVisible.isSupplier
                            ? order.supplier
                            : order.centralSupplier,
                        }}
                        isLoading={isLoading}
                        settingOrderInfoVisible={settingOrderInfoVisible}
                        settingQuantityVisible={settingQuantityVisible}
                      />
                    </WrapperPrint>

                    {orders.length > 0 && (
                      <div style={{ display: 'none' }}>
                        <WrapperPrint ref={componentRef}>
                          {orders.map(item => (
                            <K80BillContent
                              bill={{
                                ...item,
                                supplier: settingOrderInfoVisible.isSupplier
                                  ? item.supplier
                                  : item.centralSupplier,
                              }}
                              isLoading={isLoading}
                              settingOrderInfoVisible={settingOrderInfoVisible}
                              settingQuantityVisible={settingQuantityVisible}
                            />
                          ))}
                        </WrapperPrint>
                      </div>
                    )}
                  </WrapperBorder>
                )}
              </BodyBillSection>
              <FooterBillSection>
                <Row
                  justifyContent="space-between"
                  styles={{ gap: 12 }}
                  width="100%"
                >
                  {!exportBillModal.data.isMultiMode ? (
                    <>
                      <Row styles={{ gap: 6 }} width="fit-content">
                        {billingType != BILL_TYPE[2] &&
                          (isLoadingBlog || isLoading ? (
                            <>
                              <LoadingOutlined
                                style={{
                                  fontSize: 16,
                                  color: theme.colors.text.secondary,
                                }}
                              />
                              <Text size="xxs" weight="medium">
                                Đang tải file
                              </Text>
                            </>
                          ) : (
                            <>
                              <CheckFilledIcon
                                color={theme.colors.success}
                                height={16}
                                width={16}
                              />
                              <Text
                                size="xxs"
                                styles={{ color: theme.colors.success }}
                                weight="medium"
                              >
                                Tải file thành công
                              </Text>
                            </>
                          ))}
                      </Row>
                      <Row styles={{ gap: 8 }} width="fit-content">
                        <ReactToPrint
                          content={() => {
                            if (billingType.code === 'A4') {
                              return document.getElementById('A4Content');
                            }
                            return componentRef.current;
                          }}
                          documentTitle={buildExportFileName(
                            `${billingType.fileName} ${order.code}`
                          )}
                          pageStyle={
                            billingType.code === 'K80'
                              ? K80PageStyle
                              : PageStyle
                          }
                          trigger={() => (
                            <CButton
                              key="2"
                              disabled={isLoading}
                              height={theme.button.height.sm}
                              type={ButtonType.Default}
                              width="100px"
                            >
                              In
                            </CButton>
                          )}
                        />

                        {billingType.code != 'A4' && (
                          <>
                            <Button
                              key="1"
                              disabled={isLoading}
                              height={theme.button.height.sm}
                              loading={isLoadingDownload}
                              type={ButtonType.Default}
                              width="100px"
                              onClick={handleDownload}
                            >
                              Tải xuống
                            </Button>
                            {['NORMAL', 'PAYMENT', 'WAREHOUSE'].includes(
                              billingType.code
                            ) && (
                                <Button
                                  key="1"
                                  disabled={isLoading}
                                  height={theme.button.height.sm}
                                  loading={isLoadingDownloadExcel}
                                  type={ButtonType.Default}
                                  width="100px"
                                  onClick={() =>
                                    buildExportFunction(billingType.code)
                                  }
                                >
                                  Tải excel
                                </Button>
                              )}

                            <CButton
                              key="2"
                              disabled={isLoading || isLoadingBlog}
                              height={theme.button.height.sm}
                              loading={isLoadingCopy}
                              type={ButtonType.Primary}
                              width="100px"
                              onClick={handleCopy}
                            >
                              Sao chép
                            </CButton>
                          </>
                        )}
                      </Row>
                    </>
                  ) : (
                    <Row justifyContent="flex-end" width="100%">
                      <ReactToPrint
                        content={() => componentRef.current}
                        documentTitle={buildExportFileName(
                          `${billingType.fileName} ${order.code}`
                        )}
                        pageStyle={
                          billingType.code === 'K80' ? K80PageStyle : PageStyle
                        }
                        trigger={() => (
                          <CButton
                            key="2"
                            disabled={isLoading}
                            height={theme.button.height.sm}
                            type={ButtonType.Default}
                            width="100px"
                          >
                            In ({orders.length})
                          </CButton>
                        )}
                      />
                    </Row>
                  )}
                </Row>
              </FooterBillSection>
            </BillSection>
          </RightWrapper>
        </Wrapper>
      </Modal>
    </Wrapper>
  );
};

export default ElectronicBillModal;
